import React from 'react';
import HeroSection from '../components/Sections/HeroSection';
import ContactForm from '../components/common/ContactForm';
import {
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaClock,
  FaWhatsapp,
  FaLinkedin,
  FaFacebook,
  FaInstagram
} from 'react-icons/fa';
import "../styles/Contact.css"; // Custom CSS

const Contact = () => {
  return (
    <div className="mp-contact-page">
      <HeroSection
        title="Get In Touch"
        subtitle="Let's discuss how we can help transform your business"
        showButtons={false}
      />

      <section className="mp-contact-section">
        <div className="mp-contact-grid">

          {/* Contact Information */}
          <div className="mp-contact-info">
            <h2 className="mp-section-title">Contact Information</h2>

            <div className="mp-contact-item">
              <FaMapMarkerAlt className="mp-icon" />
              <div>
                <h6>Our Office</h6>
                <p>Chennai, Tamil Nadu, India<br />(Multiple locations across Tamil Nadu)</p>
              </div>
            </div>

            <div className="mp-contact-item">
              <FaPhone className="mp-icon" />
              <div>
                <h6>Phone Numbers</h6>
                <p>+91 98765 43210<br />+91 87654 32109</p>
              </div>
            </div>

            <div className="mp-contact-item">
              <FaEnvelope className="mp-icon" />
              <div>
                <h6>Email Address</h6>
                <p>info@mpeoples.in<br />support@mpeoples.in</p>
              </div>
            </div>

            <div className="mp-contact-item">
              <FaWhatsapp className="mp-icon whatsapp" />
              <div>
                <h6>WhatsApp Business</h6>
                <p>+91 98765 43210</p>
                <a href="https://wa.me/919876543210" className="mp-btn mp-btn-success">
                  Chat on WhatsApp
                </a>
              </div>
            </div>

            {/* Social Media */}
            <div className="mp-socials">
              <h6 className='mp-section-title'>Follow Us</h6>
              <div className="mp-social-icons">
                <a href="https://facebook.com"><FaFacebook /></a>
                <a href="https://linkedin.com"><FaLinkedin /></a>
                <a href="https://instagram.com"><FaInstagram /></a>
              </div>
            </div>

            {/* Websites */}
            {/* <div className="mp-websites">
              <h6>Our Websites</h6>
              <div className="mp-website-card">
                <p><strong>Main Website:</strong><br />
                  <a href="https://www.mpeoples.in">www.mpeoples.in</a>
                </p>
                <p><strong>Demo Website:</strong><br />
                  <a href="https://www.mpeoplesdemo.com">www.mpeoplesdemo.com</a>
                </p>
              </div>
            </div> */}
          </div>

          {/* Contact Form & Quick Links */}
          <div className="mp-contact-form-section">
            <div className="mp-card">
              <h3>Send Us a Message</h3>
              <p>Fill out the form below and we'll get back to you within 24 hours.</p>
              <ContactForm />
            </div>

            <div className="mp-quick-links">
              <div className="mp-quick-card">
                <h6>Quick Support</h6>
                <p>Need immediate assistance?<br />Call: +91 98765 43210</p>
              </div>
              <div className="mp-quick-card">
                <h6>Service Inquiry</h6>
                <p>For service details and pricing<br />Email: sales@mpeoples.in</p>
              </div>
              <div className="mp-quick-card">
                <h6>Career Questions</h6>
                <p>For job applications<br />Email: careers@mpeoples.in</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map */}
      <section className="mp-map-section">
        <h3 className="mp-section-title">Find Us</h3>
        <div className="mp-map-card">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d232.54499011310565!2d78.11660920000003!3d11.668487812712085!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x401bdcb2d3c2cf55%3A0x2f3ca69cc4d4258c!2sMPeoples%20Business%20Solutions%20Pvt.%20Ltd.%2C!5e1!3m2!1sen!2sin!4v1766203824986!5m2!1sen!2sin" title="MPEOPLES Location" allowfullscreen loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </section>
    </div>
  );
};

export default Contact;
